import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistor, store } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from './context/themeProvider';
import AIRouteListener from './pages/Ai/AiRouteListener';
import { AiChatProvider } from './pages/Ai';
import { SearchProvider } from './context/searchProvider';
import * as Sentry from '@sentry/react';
import config from './../config.json';

if (config.sentry && config.sentry.dsn) {
  Sentry.init({
    dsn: config.sentry.dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: config.sentry.env,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <BrowserRouter>
            <AiChatProvider>
              <AIRouteListener />
              <ThemeProvider>
                <SearchProvider>
                  <App />
                </SearchProvider>
              </ThemeProvider>
            </AiChatProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
